export default {
  walking: "#99E7C7",
  car: "#FFB96D",
  bus: "#79C6FF",
  public_bus: "#79C6FF",
  "public bus": "#79C6FF",
  taxi: "#FC9E64",
  train: "#D6BBEB",
  bicycling: "#33D3FF",
  carpool: "#FF7D7D",
  school_bus: "#B9F0FF",
  "school bus": "#B9F0FF",
  staff: "#3F913F",
  parent: "#C82A79",
};
